const guiColors = {
    'motion-primary': '#91B821',
    'motion-primary-transparent': '#91B821e6',
    'motion-tertiary': '#73941a',

    'looks-secondary': '#6BB392',
    'looks-tertiary': 'hsla(157, 35%, 46%, 1)',
    'looks-transparent': '#6BB39259',
    'looks-light-transparent': '#6BB39226',
    'looks-secondary-dark': 'hsla(157, 35%, 56%, 1)',

    'extensions-primary': 'hsla(73, 70%, 43%, 1)',
    'extensions-tertiary': 'hsla(73, 70%, 26%, 1)',
    'extensions-transparent': 'hsla(73, 70%, 43%, 0.35)',
    'extensions-light': 'hsla(157, 35%, 56%, 1)',

    'drop-highlight': '#b8d455'
};

const blockColors = {
    checkboxActiveBackground: '#91B821',
    checkboxActiveBorder: '#73941a'
};

export {
    guiColors,
    blockColors
};
